import { Injectable, OnDestroy } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Subject, throwError } from 'rxjs';

@Injectable()
export abstract class GraphQLData implements OnDestroy {
	protected vars: Record<string, any> = {};
	private destroyed$ = new Subject<void>();
	public command?: DocumentNode;

	constructor(protected apollo: Apollo) {}

	ngOnDestroy(): void {
		this.destroyed$.next();
		this.destroyed$.complete();
	}

	// Operate on the record 'input' always, merge if any data exists
	input(value: Record<string, any>) {
		const current = this.vars['input'] || {};
		this.vars['input'] = { ...current, ...value };
		return this;
	}

	protected handleError(error: any) {
		return throwError(() => error);
	}
}
